import { useState } from 'react';
import classnames from 'classnames';
import css from 'styled-jsx/css';
import PropTypes from 'prop-types';
import user from '../../src/services/api/user';
import travelersApi from '../../src/services/api/travelers';
import countryApi from '../../src/services/api/countries';
import { redirect, fetchOpts, baseUrlOf } from '../../src/lib/ssr';

import Head from 'next/head';
import Link from 'next/link';
import Button from '../../src/components/common/elements/Button';
import Header from '../../src/components/common/Header';
import Footer from '../../src/components/common/Footer';
import Nav from '../../src/components/profile/Nav';
import MainContainer from '../../src/components/common/elements/MainContainer';
import SupportForm from '../../src/components/common/elements/SupportForm';
import TravelersList from '../../src/components/profile/TravelersList';
import UserProfileForm from '../../src/components/profile/UserProfileForm';
import UserProfile, {
  MIN_DESKTOP_WIDTH as USERPROFILE_BREAKPOINT
} from '../../src/components/profile/UserProfile';
import { HREF as PROFILE_HREF } from '../profile';
import IconButton from '../../src/components/common/elements/IconButton';

const TITLE = 'Profils voyageurs';
const HREF = '/profile/travelers';

const styles = css`
  .user-profile {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  @media (min-width: ${USERPROFILE_BREAKPOINT}) {
    .user-profile {
      flex-direction: row;
    }
  }
`;
const dynamicStyles = css.resolve`
  .edit-icon {
    margin: 18px 0 0 0;
  }
  @media (min-width: ${USERPROFILE_BREAKPOINT}) {
    .edit-icon {
      margin: 0 0 0 18px;
    }
  }
`;

const Travelers = ({ profile, travelers, countries }) => {
  const [editForm, setEditForm] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(profile);
  const saveUser = async profile => {
    const userProfile = await user.update(profile);
    if (userProfile.ok) {
      setEditForm(false);
      setCurrentProfile(profile);
    }
  };

  const cancelEdit = () => {
    setEditForm(false);
  };

  return (
    <>
      <Head>
        <title key="title">YUPWEGO - {TITLE}</title>
      </Head>
      <Header profile={profile} />
      <MainContainer>
        <h1 className="sr-only">{TITLE}</h1>
        <Nav current={HREF} />
        <h2>Votre Profil</h2>
        <div className="user-profile">
          {editForm ? (
            <UserProfileForm
              profile={currentProfile}
              countries={countries}
              saveUser={saveUser}
              cancelEdit={cancelEdit}
            />
          ) : (
            <>
              <UserProfile profile={currentProfile} />
              <IconButton
                className={classnames('edit-icon', dynamicStyles.className)}
                icon="edit"
                size="m"
                alt="Editer le profil"
                onClick={() => setEditForm(true)}
              />
            </>
          )}
        </div>
        <h2>Autres voyageurs</h2>
        <TravelersList travelers={travelers} countries={countries} />
        <Link href={PROFILE_HREF}>
          <Button href={PROFILE_HREF} secondary>
            Retour au profil
          </Button>
        </Link>
      </MainContainer>
      <SupportForm />
      <Footer />
      <style jsx>{styles}</style>
      {dynamicStyles.styles}
    </>
  );
};

Travelers.getInitialProps = async ({ req, res }) => {
  const baseUrl = baseUrlOf(req);
  const opts = fetchOpts(req, res);
  const [profile, travelers, countries] = await Promise.all([
    user.profile(req, res),
    travelersApi.list(baseUrl, opts),
    countryApi.get(req)
  ]);

  if (profile) {
    return { profile, travelers, countries };
  } else {
    redirect(res, '/login?returnTo=' + req.url);
  }
};

Travelers.propTypes = {
  profile: PropTypes.object.isRequired,
  travelers: PropTypes.array.isRequired
};

export default Travelers;
export { HREF };
